import * as React from 'react';

import { translate } from '~l10n/client';

export default class Loader extends React.Component {
  render() {
    let text = this.props.text || translate('Loading…');

    return (
      <div
        className={
          'loader-container' +
          (this.props.className ? ' ' + this.props.className : '')
        }
      >
        <span className="loading-text">{text}</span>
        <div className="dot1" />
        <div className="dot2" />
        <div className="dot3" />
      </div>
    );
  }
}
